import { autoUnsubscribe } from "../../../core/decorators/auto-unsubscribe.decorator";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { MigrationsService } from "src/app/core/api/migrations.service";
import { Collection } from "src/app/core/models/collection";
import { CollectionFile } from "src/app/core/models/collection-file";
import { ToastrService } from "ngx-toastr";



@autoUnsubscribe({ autoInclude: true })
@Component({
  standalone: false,
  selector: 'app-migrate-collection-dialog',
  templateUrl: './migrate-collection.dialog.html',
  styleUrls: ['./migrate-collection.dialog.scss']
})
export class MigrateCollectionDialog implements OnInit, OnDestroy {

  private allowedMigrations$: Subscription;
  public allowedMigrations: string[] = []
  public inProgress = true;
  public inputData: { name: string, description: string, targetPartition: string } = { name: '', description: '', targetPartition: '' };

  constructor(
    private toastrService: ToastrService,
    private dialogRef: MatDialogRef<MigrateCollectionDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { collection: Collection, model: { id: string, files: CollectionFile[] } },
    private migrationsService: MigrationsService
  ) {
    this.inputData.name = this.data.collection.name;
    this.inputData.description = this.data.collection.description;
  }

  ngOnInit(): void {
    this.allowedMigrations$ = this.migrationsService.getAllowedMigrations().subscribe(allowedMigrations => {
      this.inProgress = false;
      allowedMigrations.push('');
      this.allowedMigrations = allowedMigrations;
    });
  }
  ngOnDestroy(): void {
    console.log('ondestroy MigrateCollectionDialog');
  }

  migrationDisabled(): boolean {
    return !this.inputData.name.trim() || !this.inputData.description.trim() || !this.inputData.targetPartition.trim();
  }

  migrate() {
    const collectionToBeMigrated = {
      sourceCollectionId: this.data.collection.id,
      targetCollectionName: this.inputData.name,
      targetCollectionDescription: this.inputData.description,
      sourceModelId: this.data.model.id
    };

    this.inProgress = true;
    this.migrationsService.initiateMigration(this.inputData.targetPartition, collectionToBeMigrated).subscribe(_ => {
      this.inProgress = false;
      this.toastrService.success('Migration was Queued successfully');
      this.dialogRef.close();
    }, err => {
      this.inProgress = false;
      this.toastrService.error('Attemp to Migrate failed');
    });
  }



}
